import { Modal } from "react-bootstrap";
import React from "react";
import Context from "../../Context";
import Blocker from "../Misc/Blocker";

export default class EssenceAreaChange extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      pending: false,
      items: {},
    };
  }
  onOpen = () => {
    this.setState({ show: true }, () => this.load());
  };
  onClose = () => {
    this.setState({ show: false });
  };
  onChange = (area) => {
    this.setState({ pending: true });

    let result = this.context.api.q("/document/change/area", {
      id: this.props.item.id,
      area: area.id,
    });
    if (result !== false) {
      this.context.toast(`Подразделение изменено`, "success");
      if (this.props.onFinish) {
        this.props.onFinish();
      }
      this.setState({ pending: false }, () => this.onClose());
    } else {
      this.context.toast(`Не удалось изменить подразделение`, "error");
      this.setState({ pending: false });
    }
  };
  load = async () => {
    this.setState({ pending: true });
    let items = await this.context.api.qoo("/member/area");
    this.setState({ pending: false, items });
  };
  render() {
    const levelMargins = {
      0: "ml-0",
      1: "ml-0",
      2: "ml-3",
      3: "ml-6",
      4: "ml-8",
      5: "ml-10",
      6: "ml-12",
    };

    const essenceItem = this.props.item || {};

    return (
      <>
        <Modal show={this.state.show} onHide={this.onClose}>
          <Modal.Header closeButton>
            <Modal.Title className="w-100">Сменить подразделение:</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Blocker on={this.state.pending}>
              {Object.entries(this.state.items).map(([id, item]) => {
                let margin = levelMargins[item.level];
                if (item.typecode === "root") return null;
                return (
                  <div
                    key={id}
                    onClick={() => this.onChange(item)}
                    className={`${margin} py-1 cursor-pointer ${
                      essenceItem.area === item.id ? "text-primary" : ""
                    } text-hover-primary`}
                  >
                    {item.name}
                  </div>
                );
              })}
            </Blocker>
          </Modal.Body>
        </Modal>
        {this.props.button(this.onOpen)}
      </>
    );
  }
}
